import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53d861aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left text-lg px-[16px] flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Legendas")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left px-2 pb-1 pt-2 flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Alocação")
], -1))
const _hoisted_3 = {
  class: "flex items-center gap-2 text-sm font-bold text-textPrimary whitespace-nowrap",
  "data-testid": "legend-unidentified-entry"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "legend-unidentified-swatch",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "legend-new-tag",
  "data-testid": "legend-unidentified-new-tag"
}, "NOVO", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left px-2 pb-1 pt-4 flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Avisos")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left px-2 pb-1 pt-4 flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Médico")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left px-2 pb-1 pt-2 flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Registro de plantão")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left px-2 pb-1 pt-4 flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Excepcionalidade")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left px-2 pb-1 pt-4 flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Pós-Plantão")
], -1))

import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import {
  DoctorStationStatus,
  doctorStationStatusTranslate
} from '@/translations/doctor.station.status'
import {
  mdiTextBoxCheck,
  mdiAccountAlert,
  mdiClockAlertOutline,
  mdiClockCheckOutline,
  mdiClockEnd,
  mdiLock,
  mdiLockOpenVariant
} from '@mdi/js'
import LegendTable, { ELegendColor } from '@/components/others/Legend.vue'
import { useLegendShowsUnidentified } from './useLegendShowsUnidentified'
import { stationPalette } from '@/theme/stationPalette'
import { COVERAGE_STATUS_LABELS } from '@/utils/coverage'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'

// Paleta v3: bolinhas de Alocação com os hex da paleta; antiga: classes de hoje (swatch vazio).

export default /*#__PURE__*/_defineComponent({
  __name: 'legends.modal',
  setup(__props) {

const palette = stationPalette()
const legacyPalette = palette.id === 'legacy'
const swatches = {
  open: legacyPalette ? '' : palette.open.stripe,
  FIXO: legacyPalette ? '' : palette.type.FIXO.stripe,
  COBERTURA: legacyPalette ? '' : palette.type.COBERTURA.stripe,
  offTeam: legacyPalette ? '' : palette.offTeam.stripe,
  EXTRA: legacyPalette ? '' : palette.type.EXTRA.stripe
}

/* ******** Modal Props and Actions Default *********** */
const modalName = EModals.LEGENDS
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}
/* **************************************************** */

// "Ocupado s/ identificação" só quando a resposta conhece o estado (mesma regra da legenda V2).
const showUnidentified = useLegendShowsUnidentified()

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)]
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "px-2 pb-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendColor: _unref(ELegendColor).alert,
                        text: "Aberta",
                        swatch: swatches.open
                      }, null, 8, ["legendColor", "swatch"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendColor: _unref(ELegendColor).default,
                        text: "Fixo",
                        swatch: swatches.FIXO
                      }, null, 8, ["legendColor", "swatch"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendColor: _unref(ELegendColor).warning,
                        text: "Cobertura",
                        swatch: swatches.COBERTURA
                      }, null, 8, ["legendColor", "swatch"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendColor: _unref(ELegendColor).neutral,
                        text: "Time externo",
                        swatch: swatches.offTeam
                      }, null, 8, ["legendColor", "swatch"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendColor: _unref(ELegendColor).success,
                        text: "Extra",
                        swatch: swatches.EXTRA
                      }, null, 8, ["legendColor", "swatch"])
                    ]),
                    _: 1
                  }),
                  (_unref(showUnidentified))
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12",
                        class: "py-1 px-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createTextVNode(" " + _toDisplayString(_unref(COVERAGE_STATUS_LABELS)[_unref(CoverageStatus).UNIDENTIFIED]) + " ", 1),
                            _hoisted_5
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _hoisted_6,
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendColor: _unref(ELegendColor).yellowAlert,
                        text: "Alerta leve"
                      }, null, 8, ["legendColor"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendColor: _unref(ELegendColor).alert,
                        text: "Alerta grave"
                      }, null, 8, ["legendColor"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendColor: _unref(ELegendColor).negative,
                        text: "Alerta crítico"
                      }, null, 8, ["legendColor"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_7,
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiTextBoxCheck),
                        legendColor: _unref(ELegendColor).warning,
                        text: "Possui observações"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiClockAlertOutline),
                        legendColor: _unref(ELegendColor).neutral,
                        text: "Não confirmado"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiClockCheckOutline),
                        legendColor: _unref(ELegendColor).success,
                        text: "Confirmado"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiAccountAlert),
                        legendColor: _unref(ELegendColor).default,
                        text: "Médico pendente"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        dynamicComponent: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).DISPONIBILIZADO_PARA_CHECKIN].icon
              ,
                        legendColor: _unref(ELegendColor).primary,
                        text: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).DISPONIBILIZADO_PARA_CHECKIN].text
              
                      }, null, 8, ["dynamicComponent", "legendColor", "text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        dynamicComponent: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKIN_NAO_REALIZADO].icon
              ,
                        legendColor: _unref(ELegendColor).primary,
                        text: _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKIN_NAO_REALIZADO].text
                      }, null, 8, ["dynamicComponent", "legendColor", "text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        dynamicComponent: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKIN_REALIZADO].icon
              ,
                        legendColor: _unref(ELegendColor).primary,
                        text: _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKIN_REALIZADO].text
                      }, null, 8, ["dynamicComponent", "legendColor", "text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        dynamicComponent: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKIN_REALIZADO_COM_ATRASO].icon
              ,
                        legendColor: _unref(ELegendColor).primary,
                        text: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKIN_REALIZADO_COM_ATRASO].text
              
                      }, null, 8, ["dynamicComponent", "legendColor", "text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        dynamicComponent: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).DISPONIBILIZADO_PARA_CHECKOUT].icon
              ,
                        legendColor: _unref(ELegendColor).primary,
                        text: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).DISPONIBILIZADO_PARA_CHECKOUT].text
              
                      }, null, 8, ["dynamicComponent", "legendColor", "text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        dynamicComponent: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKOUT_NAO_REALIZADO].icon
              ,
                        legendColor: _unref(ELegendColor).primary,
                        text: _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKOUT_NAO_REALIZADO].text
                      }, null, 8, ["dynamicComponent", "legendColor", "text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        dynamicComponent: 
                _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKOUT_REALIZADO].icon
              ,
                        legendColor: _unref(ELegendColor).primary,
                        text: _unref(doctorStationStatusTranslate)[_unref(DoctorStationStatus).CHECKOUT_REALIZADO].text
                      }, null, 8, ["dynamicComponent", "legendColor", "text"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        dynamicComponent: 
                _unref(doctorStationStatusTranslate)[
                  _unref(DoctorStationStatus).CHECKOUT_REALIZADO_COM_ANTECEDENCIA
                ].icon
              ,
                        legendColor: _unref(ELegendColor).primary,
                        text: 
                _unref(doctorStationStatusTranslate)[
                  _unref(DoctorStationStatus).CHECKOUT_REALIZADO_COM_ANTECEDENCIA
                ].text
              
                      }, null, 8, ["dynamicComponent", "legendColor", "text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_9,
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiLock),
                        legendColor: _unref(ELegendColor).alert,
                        text: "Em Andamento"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiLockOpenVariant),
                        legendColor: _unref(ELegendColor).negative,
                        text: "Aprovado"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiLockOpenVariant),
                        legendColor: _unref(ELegendColor).yellowAlert,
                        text: "Em revisão"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_10,
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiClockEnd),
                        legendColor: _unref(ELegendColor).success,
                        text: "Avaliação aprovada"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LegendTable, {
                        legendIcon: _unref(mdiClockEnd),
                        legendColor: _unref(ELegendColor).alert,
                        text: "Revisar avaliação"
                      }, null, 8, ["legendIcon", "legendColor"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})